import GenerateCampaignInput from '@Web/Src/Components/GenerateCampaignInput';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import { assetUrl } from '@Shared/Helpers/Utilities';

function GenerateCampaign() {
    return (
        <div
            className={
                'bg-builder bg-animated-slow bg-defaults bg-opacity relative flex h-lvh min-h-60 w-full flex-col items-center justify-center !bg-[length:300%] px-6 py-16 font-sans'
            }
        >
            <img
                src={assetUrl('/assets/images/svg/small_logo.svg')}
                alt='decor'
                className='z-[1] mb-8 w-[53px]'
            />
            <SectionHeader
                type='light'
                className='relative z-[1]'
                title={__('Build a referral program in minutes :symbol', {
                    symbol: '👇',
                })}
            />
            <GenerateCampaignInput
                buttonName={__('Start')}
                redirect_to={'embed'}
                className={'mt-12 w-full max-w-2xl'}
            />
            <p className='text-light z-[1] mt-8 text-center'>
                {__(
                    'Pssst… we’ll also invite over 100,000 affiliates to join your referral program — totally free!'
                )}
            </p>
        </div>
    );
}

export default GenerateCampaign;
